"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOrderAddInfo = void 0;
const Base_1 = require("./Base");
exports.GetOrderAddInfo = {
    url: Base_1.URL_BASE + "/GetOrderAddInfo",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetOrderAddInfo.js.map